import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faCircleArrowUp } from '@fortawesome/pro-light-svg-icons';

export type ProLightCircleArrowUpProps = IconComponentProps;

export const ProLightCircleArrowUp = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightCircleArrowUpProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faCircleArrowUp}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faCircleArrowUp}
    />
  );
};

ProLightCircleArrowUp.displayName = 'ProLightCircleArrowUp';
